import Repository from "../../repository";

export default {
    ReportDetected: (payload) => Repository.post(`/api/ReportGasFamily/ReportDetected`, payload),
    ReportEndGas: (payload) => Repository.post(`/api/ReportGasFamily/ReportEndGas`, payload),
    LogDetected: (payload) => Repository.post(`/api/ReportGasFamily/LogDetected`, payload),
    LogEndGas: (payload) => Repository.post(`/api/ReportGasFamily/LogEndGas`, payload),
    HistoryGasFamily: (payload) => Repository.post(`/api/ReportGasFamily/HistoryGasFamily`, payload),
}
